/* bundle-builder.js — "Select your options" multi-product bundle panel.
   - Per-product summary cards with their own limit (X / N)
   - One active product pane at a time, with Previous / Next navigation
   - Multiple colours per product, per-size steppers
   - Per-product quantity cap (cannot exceed that product's required qty)
   - Logo wizard (positions, embroidery/print, assignment style, 4 methods)
   Template-independent: boots on any [data-bndl] element. */
(function () {
  if (window.__bndlInit) return;
  window.__bndlInit = true;

  var routes = (window.Shopify && window.Shopify.routes) || {};

  function clampInt(v) {
    v = parseInt(v, 10);
    if (isNaN(v) || v < 0) v = 0;
    return v;
  }

  class BundleBuilder {
    constructor(root) {
      this.root = root;
      this.total = clampInt(root.dataset.bndlTotal);
      this.addBtn = root.querySelector('[data-bndl-add]');
      this.addLabel = root.querySelector('[data-bndl-add-label]');
      this.hint = root.querySelector('[data-bndl-hint]');
      this.errorBox = root.querySelector('[data-bndl-error]');
      this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-bndl-summary]'));
      this.panes = Array.prototype.slice.call(root.querySelectorAll('[data-bndl-pane]'));
      this.cartDrawer = document.querySelector('cart-drawer');
      this.activeIndex = 0;
      this.bind();
      this.initGarmentSwitch();
      this.setActive(0);
      this.recalc();
    }

    paneLimit(index) {
      var pane = this.panes[index];
      return pane ? clampInt(pane.dataset.prodLimit) : 0;
    }

    paneTotal(index) {
      var pane = this.panes[index];
      if (!pane) return 0;
      var t = 0;
      pane.querySelectorAll('[data-bndl-qty]').forEach(function (i) { t += clampInt(i.value); });
      return t;
    }

    paneIndexOf(el) {
      var pane = el.closest('[data-bndl-pane]');
      return pane ? clampInt(pane.dataset.bndlPane) : 0;
    }

    bind() {
      var self = this;

      // ---- Summary card click -> switch active product ----
      this.cards.forEach(function (card) {
        card.addEventListener('click', function () {
          self.setActive(clampInt(card.dataset.target));
        });
      });

      // ---- Previous / Next navigation ----
      var prevBtn = this.root.querySelector('[data-bndl-prev]');
      var nextBtn = this.root.querySelector('[data-bndl-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { self.setActive(self.activeIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { self.setActive(self.activeIndex + 1); });
      this.prevBtn = prevBtn; this.nextBtn = nextBtn;

      // ---- Per-product colour selection (multiple colours allowed) ----
      this.root.querySelectorAll('[data-bndl-prod]').forEach(function (prod) {
        // accordion toggle (chevron) — body starts open
        var toggle = prod.querySelector('[data-bndl-toggle]');
        var body = prod.querySelector('[data-bndl-body]');
        if (toggle && body) {
          toggle.addEventListener('click', function (e) {
            // don't toggle when interacting with controls inside the head (none here, but safe)
            var open = toggle.getAttribute('aria-expanded') !== 'false';
            toggle.setAttribute('aria-expanded', String(!open));
            body.hidden = open;
          });
        }
        var colourToggle = prod.querySelector('[data-bndl-colour-toggle]');
        var colourList = prod.querySelector('[data-bndl-colour-list]');
        var pill = prod.querySelector('[data-bndl-colour-pill]');
        var pillDot = prod.querySelector('[data-bndl-colour-pill-dot]');
        var pillLabel = prod.querySelector('[data-bndl-colour-pill-label]');
        var current = prod.querySelector('.bndl-colour__current');
        var empty = prod.querySelector('[data-bndl-empty]');
        var detail = prod.querySelector('[data-bndl-detail]');
        var detailImg = prod.querySelector('[data-bndl-detail-img]');

        if (colourToggle && colourList) {
          colourToggle.addEventListener('click', function () {
            var open = colourToggle.getAttribute('aria-expanded') === 'true';
            colourToggle.setAttribute('aria-expanded', String(!open));
            colourList.hidden = open;
          });
        }

        function updateColourSummary() {
          var active = prod.querySelectorAll('[data-bndl-grid]:not([hidden])');
          var names = [];
          active.forEach(function (g) { names.push(g.dataset.colour); });
          if (names.length && pill && pillLabel) {
            pillLabel.textContent = names.length === 1 ? names[0] : (names.length + ' colours selected');
            pill.hidden = false;
            if (current) current.classList.add('has-value');
          } else {
            if (pill) pill.hidden = true;
            if (current) current.classList.remove('has-value');
          }
          if (empty) empty.hidden = names.length > 0;
          if (detail) detail.hidden = names.length === 0;
        }
        prod._bndlUpdateSummary = updateColourSummary;

        prod.querySelectorAll('[data-bndl-colour]').forEach(function (opt) {
          opt.addEventListener('click', function () {
            var value = opt.dataset.bndlColour;
            var dot = opt.querySelector('.bndl-colour__dot');
            opt.classList.add('is-active');
            var grid = self.gridFor(prod, value);
            if (grid) {
              grid.hidden = false;
              if (detailImg && grid.dataset.colourImg) detailImg.src = grid.dataset.colourImg;
              if (pillDot && dot) pillDot.style.background = getComputedStyle(dot).backgroundColor;
            }
            if (colourList) colourList.hidden = true;
            if (colourToggle) colourToggle.setAttribute('aria-expanded', 'false');
            updateColourSummary();
            self.recalc();
          });
        });

        prod.querySelectorAll('[data-bndl-remove-colour]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var grid = btn.closest('[data-bndl-grid]');
            if (!grid) return;
            grid.querySelectorAll('[data-bndl-qty]').forEach(function (i) { i.value = 0; });
            grid.hidden = true;
            var colour = grid.dataset.colour;
            var opt = prod.querySelector('[data-bndl-colour="' + (window.CSS && CSS.escape ? CSS.escape(colour) : colour) + '"]');
            if (opt) opt.classList.remove('is-active');
            updateColourSummary();
            self.recalc();
          });
        });

        if (parseInt(prod.dataset.colorIndex, 10) === -1) {
          if (empty) empty.hidden = true;
          if (detail) detail.hidden = false;
          var g = prod.querySelector('[data-bndl-grid]');
          if (g) g.hidden = false;
        }
      });

      // ---- Steppers (per-product cap) ----
      this.root.addEventListener('click', function (e) {
        var minus = e.target.closest('[data-bndl-minus]');
        var plus = e.target.closest('[data-bndl-plus]');
        if (!minus && !plus) return;
        var row = e.target.closest('[data-bndl-row]');
        if (!row) return;
        var input = row.querySelector('[data-bndl-qty]');
        if (!input || input.disabled) return;
        var idx = self.paneIndexOf(input);
        var v = clampInt(input.value);
        if (plus) {
          var lim = self.paneLimit(idx);
          if (lim > 0 && self.paneTotal(idx) >= lim) { self.flashCap(idx); return; }
          v = v + 1;
        } else {
          v = Math.max(0, v - 1);
        }
        input.value = v;
        self.recalc();
      });

      this.root.addEventListener('input', function (e) {
        if (!e.target.matches('[data-bndl-qty]')) return;
        var input = e.target;
        var idx = self.paneIndexOf(input);
        var val = clampInt(input.value);
        var lim = self.paneLimit(idx);
        if (lim > 0) {
          var others = self.paneTotal(idx) - clampInt(input.dataset._prev || 0);
          var allowed = lim - others;
          if (allowed < 0) allowed = 0;
          if (val > allowed) { val = allowed; self.flashCap(idx); }
        }
        input.value = val;
        input.dataset._prev = val;
        self.recalc();
      });

      // Close colour dropdowns on outside click
      document.addEventListener('click', function (e) {
        if (self.root.contains(e.target)) return;
        self.root.querySelectorAll('[data-bndl-colour-list]').forEach(function (l) { l.hidden = true; });
        self.root.querySelectorAll('[data-bndl-colour-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      });

      this.addBtn.addEventListener('click', function () { self.openWizard(); });
    }

    // ---- Garment-type switcher (Polo<->T-Shirt, Hoodie<->Sweatshirt, Outerwear) ----
    // Each category pane may contain multiple garment options. Only the active one is
    // visible; the others are reset to 0 so they never count toward the bundle or cart.
    initGarmentSwitch() {
      var self = this;
      this.root.querySelectorAll('[data-bndl-garment-switch]').forEach(function (sw) {
        var pane = sw.closest('[data-bndl-pane]');
        if (!pane) return;
        var wrap = pane.querySelector('[data-bndl-garments]');
        if (!wrap) return;
        var tabs = Array.prototype.slice.call(sw.querySelectorAll('[data-bndl-garment-tab]'));
        var garments = Array.prototype.slice.call(wrap.querySelectorAll('[data-bndl-garment]'));
        var card = self.cards[clampInt(pane.dataset.bndlPane)];
        var labelEl = card ? card.querySelector('.bndl-summary__label') : null;

        function activate(index) {
          garments.forEach(function (g) {
            var on = clampInt(g.dataset.bndlGarment) === index;
            if (!on) self.resetGarment(g);
            g.hidden = !on;
          });
          tabs.forEach(function (t) {
            var on = clampInt(t.dataset.bndlGarmentTab) === index;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            if (on && labelEl && t.dataset.garmentTitle) labelEl.textContent = t.dataset.garmentTitle;
          });
          self.recalc();
        }

        tabs.forEach(function (t) {
          t.addEventListener('click', function () { activate(clampInt(t.dataset.bndlGarmentTab)); });
        });
      });
    }

    resetGarment(garment) {
      // Zero quantities so a hidden garment never counts toward the bundle or the cart.
      garment.querySelectorAll('[data-bndl-qty]').forEach(function (i) {
        i.value = 0;
        i.dataset._prev = 0;
      });
      // Collapse any open colour size grids and clear active colour chips.
      garment.querySelectorAll('[data-bndl-grid]').forEach(function (g) { g.hidden = true; });
      garment.querySelectorAll('[data-bndl-colour].is-active').forEach(function (o) { o.classList.remove('is-active'); });
      var prod = garment.querySelector('[data-bndl-prod]');
      if (prod && typeof prod._bndlUpdateSummary === 'function') prod._bndlUpdateSummary();
    }

    setActive(index) {
      if (index < 0) index = 0;
      if (this.panes.length && index > this.panes.length - 1) index = this.panes.length - 1;
      this.activeIndex = index;
      this.panes.forEach(function (p, i) { p.hidden = i !== index; });
      this.cards.forEach(function (c) { c.classList.toggle('is-active', clampInt(c.dataset.target) === index); });
      if (this.prevBtn) this.prevBtn.disabled = index <= 0;
      if (this.nextBtn) this.nextBtn.disabled = index >= this.panes.length - 1;
    }

    gridFor(prod, colour) {
      var grids = prod.querySelectorAll('[data-bndl-grid]');
      for (var i = 0; i < grids.length; i++) {
        if (grids[i].dataset.colour === colour) return grids[i];
      }
      return null;
    }

    currentTotal() {
      var t = 0;
      this.root.querySelectorAll('[data-bndl-qty]').forEach(function (i) { t += clampInt(i.value); });
      return t;
    }

    flashCap(idx) {
      var self = this;
      var lim = this.paneLimit(idx);
      if (this.hint) {
        this.hint.textContent = 'This product is limited to ' + lim + '.';
        this.hint.classList.add('is-cap');
        clearTimeout(this._capT);
        this._capT = setTimeout(function () { self.hint.classList.remove('is-cap'); self.recalc(); }, 1500);
      }
    }

    recalc() {
      var self = this;
      var grand = 0;
      var allComplete = true;

      this.panes.forEach(function (pane) {
        var idx = clampInt(pane.dataset.bndlPane);
        var lim = clampInt(pane.dataset.prodLimit);
        var sum = self.paneTotal(idx);
        grand += sum;

        var atCap = lim > 0 && sum >= lim;
        pane.querySelectorAll('[data-bndl-qty]').forEach(function (i) { i.dataset._prev = clampInt(i.value); });
        pane.querySelectorAll('[data-bndl-plus]').forEach(function (b) {
          b.disabled = atCap;
          b.style.opacity = atCap ? '0.35' : '';
          b.style.cursor = atCap ? 'not-allowed' : '';
        });

        var prodBadge = pane.querySelector('[data-bndl-prod-qty]');
        if (prodBadge) {
          pane.querySelectorAll('[data-bndl-prod-qty]').forEach(function (b) { b.textContent = sum; });
        }

        var chosenEl = self.root.querySelector('[data-bndl-prod-chosen="' + idx + '"]');
        if (chosenEl) chosenEl.textContent = sum;
        var card = self.cards[idx];
        var complete = lim > 0 && sum === lim;
        if (card) {
          card.classList.toggle('is-complete', complete);
          var hint = card.querySelector('.bndl-summary__hint');
          if (hint) hint.textContent = complete ? 'Complete!' : ('Only ' + lim + ' to Select');
        }
        if (lim > 0 && sum !== lim) allComplete = false;
      });

      this.root.querySelectorAll('[data-bndl-chosen]').forEach(function (el) { el.textContent = grand; });

      var ok = this.total > 0 ? (grand === this.total && allComplete) : grand > 0;

      if (this.total > 0 && grand < this.total) {
        this.hint.textContent = 'Choose ' + (this.total - grand) + ' more to continue.';
      } else if (this.total > 0 && !allComplete) {
        this.hint.textContent = 'Please complete each product\u2019s required quantity.';
      } else if (grand === 0) {
        this.hint.textContent = this.total > 0 ? ('Choose ' + this.total + ' products to continue.') : 'Choose your sizes to continue.';
      } else if (ok) {
        this.hint.textContent = 'Great! Your bundle is complete.';
      }

      this.addBtn.disabled = !ok;
      this.addBtn.setAttribute('aria-disabled', String(!ok));
    }

    collectItems() {
      var map = {};
      this.root.querySelectorAll('[data-bndl-qty]').forEach(function (i) {
        var qty = clampInt(i.value);
        if (qty <= 0) return;
        var id = i.dataset.variantId;
        if (!id) return;
        map[id] = (map[id] || 0) + qty;
      });
      return Object.keys(map).map(function (id) {
        return { id: Number(id), quantity: map[id] };
      });
    }

    // Human-readable summary of chosen garments, grouped by product -> colour -> size:qty.
    collectSelectionSummary() {
      var out = [];
      this.root.querySelectorAll('[data-bndl-prod]').forEach(function (prod) {
        var titleEl = prod.querySelector('.bndl-prod__title');
        var title = titleEl ? titleEl.textContent.trim() : 'Product';
        var lines = [];
        prod.querySelectorAll('[data-bndl-grid]').forEach(function (grid) {
          var colour = grid.dataset.colour || '';
          var sizes = [];
          grid.querySelectorAll('[data-bndl-row]').forEach(function (row) {
            var qtyEl = row.querySelector('[data-bndl-qty]');
            var q = qtyEl ? clampInt(qtyEl.value) : 0;
            if (q > 0) {
              var sz = row.querySelector('.bndl-row__size');
              sizes.push((sz ? sz.textContent.trim() : '?') + ' x' + q);
            }
          });
          if (sizes.length) lines.push(colour + ': ' + sizes.join(', '));
        });
        if (lines.length) out.push(title + ' \u2014 ' + lines.join(' | '));
      });
      return out;
    }

    /* ---------------- Logo wizard ---------------- */
    /* ---------------- Bundle logo wizard (single shared logo) ---------------- */
    initWizard() {
      var self = this;
      this.modal = this.root.querySelector('[data-bndl-modal]');
      if (!this.modal) return;
      if (this.modal.parentElement !== document.body) document.body.appendChild(this.modal);
      this.logo = { method: null, positions: {}, extras: {}, files: [], textLines: [], notes: '' };
      this.uploadedLogos = [];
      this.feeVariant = parseInt(this.modal.dataset.feeVariant, 10) || 0;
      this.feeAmount = parseFloat(this.modal.dataset.feeAmount || '0') || 0; // in cents (Shopify product.price)
      // Tiered embroidery/print decoration (mirrors the default customizer)
      this.decoVariant = parseInt(this.modal.dataset.bndlDecoVariant, 10) || 0;
      try { this.deco = JSON.parse(this.modal.dataset.bndlDeco || 'null'); }
      catch (e) { this.deco = null; }
      this.tieredDeco = !!(this.deco && this.deco.columns && this.decoVariant);
      this.fixedVariant = parseInt(this.modal.dataset.fixedVariant, 10) || 0;

      this.modal.querySelectorAll('[data-bndl-modal-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.closeWizard(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.modal && !self.modal.hidden) self.closeWizard();
      });

      // generic step navigation
      this.modal.querySelectorAll('[data-bndl-goto]').forEach(function (b) {
        b.addEventListener('click', function () { self.gotoStep(b.dataset.bndlGoto); });
      });

      // method selection -> open that method's detail step
      this.modal.querySelectorAll('[data-bndl-method]').forEach(function (m) {
        m.addEventListener('click', function () {
          self.modal.querySelectorAll('[data-bndl-method]').forEach(function (x) { x.classList.remove('is-active'); });
          m.classList.add('is-active');
          self.logo.method = m.dataset.bndlMethod;
          self.openMethodStep(self.logo.method);
        });
      });

      // file upload
      var dropBtn = this.modal.querySelector('[data-bndl-drop-btn]');
      var dropZone = this.modal.querySelector('[data-bndl-drop]');
      var fileInput = this.modal.querySelector('[data-bndl-detail-file]');
      var filesWrap = this.modal.querySelector('[data-bndl-drop-files]');
      function renderFiles(fileList) {
        if (!filesWrap) return;
        Array.prototype.forEach.call(fileList, function (f) {
          self.logo.files.push(f.name);
          var reader = new FileReader();
          reader.onload = function () { self.uploadedLogos.push({ name: f.name, dataUrl: reader.result }); };
          try { reader.readAsDataURL(f); } catch (e) {}
          var row = document.createElement('div');
          row.className = 'bndl-drop__filerow';
          row.innerHTML = '<span class="bndl-drop__thumb"></span><span class="bndl-drop__fname">' + f.name + '</span><button type="button" class="bndl-drop__remove" aria-label="Remove">&times;</button>';
          row.querySelector('.bndl-drop__remove').addEventListener('click', function () {
            row.remove();
            var i = self.logo.files.indexOf(f.name);
            if (i > -1) self.logo.files.splice(i, 1);
          });
          var bar = document.createElement('div'); bar.className = 'bndl-drop__bar'; bar.innerHTML = '<i></i>';
          row.appendChild(bar);
          filesWrap.appendChild(row);
          setTimeout(function () { bar.querySelector('i').style.width = '100%'; }, 30);
        });
      }
      if (dropBtn && fileInput) dropBtn.addEventListener('click', function () { fileInput.click(); });
      if (fileInput) fileInput.addEventListener('change', function () { if (fileInput.files) renderFiles(fileInput.files); });
      if (dropZone && fileInput) {
        ['dragover', 'dragenter'].forEach(function (ev) { dropZone.addEventListener(ev, function (e) { e.preventDefault(); dropZone.classList.add('is-drag'); }); });
        ['dragleave', 'drop'].forEach(function (ev) { dropZone.addEventListener(ev, function (e) { e.preventDefault(); dropZone.classList.remove('is-drag'); }); });
        dropZone.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) renderFiles(e.dataTransfer.files); });
      }

      // text logo preview
      var t1 = this.modal.querySelector('[data-bndl-text-1]');
      var t2 = this.modal.querySelector('[data-bndl-text-2]');
      var preview = this.modal.querySelector('[data-bndl-text-preview]');
      var fontSel = this.modal.querySelector('[data-bndl-text-font]');
      var colourSel = this.modal.querySelector('[data-bndl-text-colour]');
      function updatePreview() {
        if (!preview) return;
        var lines = [];
        if (t1 && t1.value.trim()) lines.push(t1.value.trim());
        if (t2 && t2.value.trim()) lines.push(t2.value.trim());
        self.modal.querySelectorAll('[data-bndl-text-extra] input').forEach(function (i) { if (i.value.trim()) lines.push(i.value.trim()); });
        preview.innerHTML = lines.length ? lines.join('<br>') : 'Threada';
        if (fontSel && fontSel.value) preview.style.fontFamily = fontSel.value;
        if (colourSel && colourSel.value) preview.style.color = colourSel.value;
      }
      [t1, t2, fontSel, colourSel].forEach(function (el) { if (el) { el.addEventListener('input', updatePreview); el.addEventListener('change', updatePreview); } });
      var addLine = this.modal.querySelector('[data-bndl-text-add]');
      var extraWrap = this.modal.querySelector('[data-bndl-text-extra]');
      if (addLine && extraWrap) addLine.addEventListener('click', function () {
        var inp = document.createElement('input');
        inp.type = 'text'; inp.className = 'bndl-modal__input'; inp.placeholder = 'e.g Threada';
        inp.addEventListener('input', updatePreview);
        extraWrap.appendChild(inp);
      });

      // Save & Continue (each method step) -> go to positions
      this.modal.querySelectorAll('[data-bndl-detail-save]').forEach(function (b) {
        b.addEventListener('click', function () { self.saveDetails(); });
      });

      // position toggles + per-position Embroidery/Print application
      this.modal.querySelectorAll('[data-bndl-pos]').forEach(function (posEl) {
        var appPanel = posEl.querySelector('[data-bndl-pos-app]');
        var locked = posEl.dataset.bndlLocked === '1';
        if (locked) {
          self.logo.positions[posEl.dataset.bndlPos] = { price: 0 };
          if (appPanel) appPanel.hidden = false; // always-on position: show its app choice
        } else {
          posEl.addEventListener('click', function (e) {
            if (e.target.closest('[data-bndl-pos-app]')) return; // clicks on the radio shouldn't toggle the card
            var name = posEl.dataset.bndlPos;
            var price = parseFloat(posEl.dataset.bndlPrice || '0') || 0;
            var on = posEl.classList.toggle('is-active');
            if (on) self.logo.extras[name] = price; else delete self.logo.extras[name];
            if (appPanel) appPanel.hidden = !on;
            self.updateFeeBar();
          });
        }
        // Embroidery/Print radios recompute the tiered charge.
        posEl.querySelectorAll('[data-bndl-app]').forEach(function (r) {
          r.addEventListener('change', function () { self.updateFeeBar(); });
        });
      });

      // finish -> add to cart (logo on every item + fee line for extras)
      var finishBtn = this.modal.querySelector('[data-bndl-finish]');
      if (finishBtn) finishBtn.addEventListener('click', function () { self.finishWizard(); });

      this._wizardReady = true;
    }

    openMethodStep(method) {
      var lc = (method || '').toLowerCase();
      var step = 'm-upload';
      if (lc.indexOf('existing') !== -1) step = 'm-existing';
      else if (lc.indexOf('send') !== -1) step = 'm-send';
      else if (lc.indexOf('text') !== -1) step = 'm-text';
      else if (lc.indexOf('upload') !== -1) step = 'm-upload';
      if (step === 'm-existing') this.renderExistingLogos();
      this.gotoStep(step);
    }

    renderExistingLogos() {
      var self = this;
      var grid = this.modal.querySelector('[data-bndl-existing-grid]');
      var label = this.modal.querySelector('[data-bndl-existing-label]');
      if (!grid) return;
      grid.innerHTML = '';
      if (!this.uploadedLogos.length) {
        if (label) label.textContent = 'No previously uploaded logos found. Upload a logo first and it will appear here.';
        return;
      }
      if (label) label.textContent = 'Select a previously uploaded logo:';
      this.uploadedLogos.forEach(function (logo) {
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'bndl-existing__item';
        var short = logo.name.length > 22 ? logo.name.slice(0, 20) + '\u2026' : logo.name;
        card.innerHTML = '<span class="bndl-existing__thumb"><img src="' + logo.dataUrl + '" alt=""></span><span class="bndl-existing__name">' + short + '</span>';
        card.addEventListener('click', function () {
          grid.querySelectorAll('.bndl-existing__item').forEach(function (x) { x.classList.remove('is-active'); });
          card.classList.add('is-active');
          self.logo.existing = logo.name;
        });
        grid.appendChild(card);
      });
    }

    saveDetails() {
      var step = this.modal.querySelector('[data-bndl-step]:not([hidden])');
      if (step) {
        var notes = step.querySelector('[data-bndl-detail-notes]');
        if (notes) this.logo.notes = notes.value.trim();
        var t1 = step.querySelector('[data-bndl-text-1]');
        if (t1) {
          var lines = [];
          step.querySelectorAll('[data-bndl-text-1],[data-bndl-text-2],[data-bndl-text-extra] input').forEach(function (i) { if (i.value.trim()) lines.push(i.value.trim()); });
          this.logo.textLines = lines;
          var fs = step.querySelector('[data-bndl-text-font]'); if (fs) this.logo.font = fs.value;
          var cs = step.querySelector('[data-bndl-text-colour]'); if (cs) this.logo.colour = cs.value;
        }
      }
      this.gotoStep('positions');
    }

    /* ---- Tiered embroidery/print decoration engine (mirrors default customizer) ---- */
    decoTierIndex(totalQty) {
      var bounds = [5, 11, 24, 49, 74, 99, 249];
      for (var i = 0; i < bounds.length; i++) { if (totalQty <= bounds[i]) return i; }
      return 7;
    }
    isLargePosition(pos) {
      var large = ['big front', 'big rear', 'front', 'back', 'back logo'];
      return large.indexOf(String(pos || '').toLowerCase()) !== -1;
    }
    priceColumnFor(pos, application, method) {
      var isPrint = String(application || '').toLowerCase() === 'print';
      var large = this.isLargePosition(pos);
      if (isPrint) return large ? 'print_big' : 'print_small';
      if (String(method || '').toLowerCase().indexOf('text') !== -1) return 'emb_text';
      return large ? 'emb_bf' : 'emb_small';
    }
    columnPrice(key, tierIdx) {
      if (!this.deco || !this.deco.columns) return 0;
      var col = null;
      for (var i = 0; i < this.deco.columns.length; i++) { if (this.deco.columns[i].key === key) { col = this.deco.columns[i]; break; } }
      if (!col) return 0;
      var v = Number(col.prices[tierIdx]);
      return isNaN(v) ? 0 : v;
    }
    // All currently-active position cards + their chosen application (Embroidery/Print).
    activePositions() {
      if (!this.modal) return [];
      var out = [];
      this.modal.querySelectorAll('[data-bndl-pos].is-active, [data-bndl-pos][data-bndl-locked="1"]').forEach(function (card) {
        var name = card.dataset.bndlPos;
        var sel = card.querySelector('[data-bndl-app]:checked');
        var app = sel ? sel.value : 'Embroidery';
        var isFree = card.dataset.bndlLocked === '1' || card.classList.contains('is-free');
        out.push({ pos: name, application: app, free: isFree });
      });
      // de-dupe (locked card may also match .is-active)
      var seen = {}, uniq = [];
      out.forEach(function (o) { if (!seen[o.pos]) { seen[o.pos] = 1; uniq.push(o); } });
      return uniq;
    }
    // Tiered decoration cost in POUNDS for the current selection.
    decorationCost() {
      var deco = this.deco;
      var totalQty = this.currentTotal();
      var positions = this.activePositions();
      if (!deco || !deco.columns || !positions.length || totalQty <= 0) {
        return { perUnit: 0, setup: 0, total: 0, lines: [], tierIdx: 0 };
      }
      var tierIdx = this.decoTierIndex(totalQty);
      var setup = deco.setup || {};
      var setupFree = totalQty >= (Number(setup.free_from_qty) || Infinity);
      var setupPrice = Number(setup.price) || 0;
      var method = (this.logo && this.logo.method) || '';
      var methodLc = String(method).toLowerCase();
      var isNoSetupMethod = methodLc.indexOf('stock') !== -1 || methodLc.indexOf('trade') !== -1 || methodLc.indexOf('existing') !== -1;
      var self = this;
      var perUnit = 0, setupTotal = 0, lines = [];
      positions.forEach(function (p) {
        if (p.free) {
          // Left Chest (or category-equivalent) is included free — no per-item or setup charge.
          lines.push({ pos: p.pos, application: p.application, key: null, unit: 0, setup: 0, free: true });
          return;
        }
        var key = self.priceColumnFor(p.pos, p.application, method);
        var unit = self.columnPrice(key, tierIdx);
        perUnit += unit;
        var posSetup = 0;
        if (String(p.application).toLowerCase() !== 'print' && !setupFree && !isNoSetupMethod) {
          posSetup = setupPrice; setupTotal += posSetup;
        }
        lines.push({ pos: p.pos, application: p.application, key: key, unit: unit, setup: posSetup });
      });
      var total = perUnit * totalQty + setupTotal;
      return { perUnit: perUnit, setup: setupTotal, total: total, lines: lines, tierIdx: tierIdx, setupFree: setupFree };
    }

    updateFeeBar() {
      var bar = this.modal.querySelector('[data-bndl-feebar]');
      var totalEl = this.modal.querySelector('[data-bndl-feetotal]');
      var note = this.modal.querySelector('[data-bndl-feenote]');
      var qty = this.currentTotal();

      if (this.tieredDeco) {
        var d = this.decorationCost();
        if (totalEl) totalEl.textContent = '\u00a3' + d.total.toFixed(2);
        if (bar) bar.hidden = d.total <= 0;
        if (note) {
          if (d.total > 0) {
            note.hidden = false;
            var setupTxt = d.setup > 0 ? ' (includes \u00a3' + d.setup.toFixed(2) + ' setup)' : (d.setupFree ? ' (setup FREE on 25+)' : '');
            note.textContent = '\u00a3' + d.perUnit.toFixed(2) + ' per item \u00d7 ' + qty + ' garments' + setupTxt + '. Charges are added to your cart.';
          } else { note.hidden = true; }
        }
        return;
      }

      // ---- legacy flat per-position surcharge (when penny product not configured) ----
      var names = Object.keys(this.logo.extras);
      var perGarment = this.extrasPerGarment();
      var total = perGarment * qty;
      var priceEl = this.modal.querySelector('.bndl-pos__price');
      var sym = (priceEl && priceEl.textContent.replace(/[0-9.+\s]/g, '')) || '\u00a3';
      if (totalEl) totalEl.textContent = sym + total.toFixed(2);
      if (bar) bar.hidden = names.length === 0;
      if (note) {
        if (names.length) {
          note.hidden = false;
          note.textContent = names.length + ' extra position' + (names.length > 1 ? 's' : '') + ' \u00d7 ' + qty + ' garments. Charges are added to your cart.';
        } else { note.hidden = true; }
      }
    }

    openWizard() {
      if (!this._wizardReady) this.initWizard();
      if (!this.modal) { this.submit({}); return; }
      this.gotoStep('method');
      this.updateFeeBar();
      this.modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    closeWizard() {
      if (this.modal) this.modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    gotoStep(name) {
      if (!this.modal) return;
      this.modal.querySelectorAll('[data-bndl-step]').forEach(function (s) {
        s.hidden = s.dataset.bndlStep !== name;
      });
      var dialog = this.modal.querySelector('.bndl-modal__dialog');
      if (dialog) dialog.scrollTop = 0;
    }

    finishWizard() {
      // Logo applies to ALL items; method required.
      if (!this.logo.method) { this.gotoStep('method'); return; }
      this.closeWizard();
      this.submit(this.buildLogoProperties());
    }

    extrasPerGarment() {
      var sum = 0;
      var ex = this.logo.extras;
      for (var k in ex) { if (ex.hasOwnProperty(k)) sum += (parseFloat(ex[k]) || 0); }
      return sum;
    }

    extraPositionsCount() {
      return Object.keys(this.logo.extras).length;
    }

    buildLogoProperties() {
      var props = {};
      var positions = [this.primaryPositionLabel()].concat(Object.keys(this.logo.extras));
      props['Logo positions'] = positions.join(', ');
      if (this.logo.method) props['Logo method'] = this.logo.method;
      if (this.logo.textLines && this.logo.textLines.length) props['Logo text'] = this.logo.textLines.join(' / ');
      if (this.logo.font) props['Logo font'] = this.logo.font;
      if (this.logo.colour) props['Logo colour'] = this.logo.colour;
      if (this.logo.files && this.logo.files.length) props['Logo files'] = this.logo.files.join(', ');
      if (this.logo.existing) props['Existing logo'] = this.logo.existing;
      if (this.logo.notes) props['Logo notes'] = this.logo.notes;
      props['Applies to'] = 'All bundle items';
      return props;
    }

    primaryPositionLabel() {
      var locked = this.modal.querySelector('[data-bndl-pos][data-bndl-locked="1"]');
      return locked ? locked.dataset.bndlPos : 'Left Chest';
    }

    async submit(properties) {
      this.errorBox.hidden = true;
      properties = properties || {};
      var items = [];

      if (this.fixedVariant) {
        // ---- Fixed bundle: ONE line item (e.g. £110), choices saved as properties ----
        var selSummary = this.collectSelectionSummary();
        var totalItems = this.currentTotal();
        var bundleProps = {};
        Object.keys(properties).forEach(function (k) { bundleProps[k] = properties[k]; });
        selSummary.forEach(function (line, i) { bundleProps['Item ' + (i + 1)] = line; });
        bundleProps['Bundle items'] = String(totalItems);
        items.push({ id: this.fixedVariant, quantity: 1, properties: bundleProps });
      } else {
        // ---- Default: each chosen garment as its own line ----
        items = this.collectItems();
        if (!items.length) return;
        if (Object.keys(properties).length) {
          items = items.map(function (it) { return { id: it.id, quantity: it.quantity, properties: properties }; });
        }
      }

      // ---- Logo decoration charge ----
      if (this.tieredDeco) {
        // Tiered embroidery/print, charged via a £0.01 penny product (qty = total pennies).
        var d = this.decorationCost();
        var cents = Math.round(d.total * 100);
        if (this.decoVariant && cents > 0) {
          var appSummary = d.lines.filter(function (l) { return !l.free; }).map(function (l) { return l.pos + ': ' + l.application; }).join(', ');
          items.push({
            id: this.decoVariant,
            quantity: cents,
            properties: {
              '_bundle_logo_fee': 'true',
              'Logo decoration': appSummary,
              'Per item': '\u00a3' + d.perUnit.toFixed(2),
              'Setup': d.setup > 0 ? '\u00a3' + d.setup.toFixed(2) : (d.setupFree ? 'FREE (25+)' : '\u00a30.00'),
              'Applies to': 'Bundle decoration charge'
            }
          });
        }
      } else if (this.logo && this.feeVariant && this.extraPositionsCount() > 0) {
        // Legacy flat per-position surcharge.
        var garments = this.currentTotal();
        var feeQty = this.extraPositionsCount() * garments;
        if (feeQty > 0) {
          var extraNames = Object.keys(this.logo.extras).join(', ');
          items.push({
            id: this.feeVariant,
            quantity: feeQty,
            properties: {
              '_bundle_logo_fee': 'true',
              'Logo positions (extra)': extraNames,
              'Applies to': 'Bundle decoration charge'
            }
          });
        }
      }

      if (!items.length) return;

      this.addBtn.classList.add('is-loading');
      var cartRoute = (routes.cartAdd || '/cart/add.js');

      try {
        var res = await fetch(cartRoute, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) {
          var err = await res.json().catch(function () { return {}; });
          throw new Error((err && err.description) || 'Could not add to cart.');
        }

        document.documentElement.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { items: items } }));

        if (this.cartDrawer && typeof this.cartDrawer.refresh === 'function') {
          this.cartDrawer.refresh(true);
          if (typeof this.cartDrawer.open === 'function') this.cartDrawer.open();
        } else if (window.location.pathname === (routes.cart || '/cart')) {
          window.location.reload();
        } else {
          window.location.href = (routes.cart || '/cart');
        }
      } catch (err) {
        this.errorBox.hidden = false;
        this.errorBox.textContent = String(err && err.message ? err.message : err);
        document.documentElement.dispatchEvent(new CustomEvent('on:cart:error', { bubbles: true, detail: { error: String(err) } }));
      } finally {
        this.addBtn.classList.remove('is-loading');
      }
    }
  }

  var boot = function (scope) {
    (scope || document).querySelectorAll('[data-bndl]').forEach(function (el) {
      if (el.__bndlMounted) return;
      el.__bndlMounted = true;
      try { el.__bndl = new BundleBuilder(el); }
      catch (e) { if (window.console && console.warn) console.warn('[bndl]', e); }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
